import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Button from '@component/form/element/button';
import I18n from '@module/i18n';

import Actions from '@app/store/action';

export function SaveButton({ onClick, save, context, text, className }) {
  const handleOnClick = () => {
    save(context);
    onClick && onClick();
  };

  return <Button text={text} className={className} onClick={handleOnClick} />;
}

SaveButton.propTypes = {
  onClick: PropTypes.func,
  save: PropTypes.func.isRequired,
  context: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
};

SaveButton.defaultProps = {
  text: I18n.t('transfer.consent-manager.button-save-and-exit'),
  className: 'welcome__button welcome__button--save-and-exit',
};

export const mapDispatchToProps = (dispatch) => ({
  save: (context) => {
    dispatch(Actions.Consent.save(context));
  },
});

export default connect(null, mapDispatchToProps)(SaveButton);
